import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { name: '人生轨迹', path: '/category/rensheng-guiji' },
      { name: '职业转型', path: '/category/zhiye-zhuanxing' },
      { name: '婚姻生活', path: '/category/hunyin-shenghuo' },
    ],
  },
  {
    title: '更多内容',
    links: [
      { name: '在华影响力', path: '/category/zaihua-yingxiangli' },
      { name: '艺术生涯', path: '/category/yishu-shengya' },
      { name: '最新动态', path: '/category/zuixin-dongtai' },
    ],
  },
  {
    title: '关于',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '隐私政策', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100/80 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="cursor-pointer">
              <span className="text-lg font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                苍井空人物志
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              还原一个真实立体的苍井空。<br />
              深度解析她的人生轨迹、职业转型与艺术生涯。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-foreground-950 mb-4">{group.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 苍井空人物志. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供信息参考，不构成任何建议。
          </p>
        </div>
      </div>
    </footer>
  );
}